<template src="./templates/index.html" />

<script type="text/ecmascript-6">
import Uploader from './uploader'
import UploaderLabel from './uploader-label'
import LiveUploaderDisable from './live-uploader-disable'
import LiveUploader from './live-uploader'
import Results from './results'
import LiveResults from './live-results'
import DefaultStyle from './defaultStyle'
import SubmissionFoundryDropdown from './submission-foundry-dd'
import Designers from './designers'
import Externalsku from './externalsku'
import { SubmissionObject, errors as submissionErrors } from 'src/pages/submissions/script/common.data'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import { mapGetters } from 'vuex'
import { useForm } from 'vee-validate'
import { isEmpty } from 'lodash'
import TextField from 'src/components/form/text-field/index.vue'

export default {
  name: 'Upload',

  components: {
    UploaderLabel,
    Uploader,
    LiveUploaderDisable,
    LiveUploader,
    Results,
    LiveResults,
    DefaultStyle,
    Designers,
    Externalsku,
    SubmissionFoundryDropdown,
    TextField
  },
  props: {
    isPreviewClicked: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { errors } = useForm()
    return {
      errors
    }
  },

  data() {
    return {
      item: SubmissionObject.getStep('upload')
    }
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('binaries', {
      binariesList: ['list']
    }),
    ...mapGetters('auth', ['user', 'hasRole']),
    isFontsPSComplete () {
      if (this.$store.getters['binaries/list'].length >= 1) {
        return this.$store.getters['binaries/hasAllPSNames'] && this.$store.getters['binaries/hasAllStyleNames']
      }
      return true
    },
  },

  watch: {
    errors: {
      handler(newVal) {
        if (isEmpty(newVal)) {
          submissionErrors.value = submissionErrors.value.filter(
            error => !Object.hasOwn(error, 'binary amount upload')
          )
        } else if (this.isPreviewClicked) {
          submissionErrors.value = []
          submissionErrors.value.push({ 'binary amount upload': this.$t('pages.submissions.components.upload.no_binaries') })
        }
      }
    },
    /**
    * If no fonts are uploaded, remove other errors from global errorSubmission and push only binary amount upload error
    */
    isPreviewClicked: {
      handler() {
        if (isEmpty(this.$store.getters['binaries/list'])) {
          submissionErrors.value = []
          submissionErrors.value.push({ 'binary amount upload': this.$t('pages.submissions.components.upload.no_binaries') })
        }
      }
    }
  },

  created() {
    this.item.set({
      context: this
    })
  }
}
</script>

<style lang="scss" src="./stylesheets/index.scss" module></style>
